import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { media } from "../../data/media";
import { btnPrimary, container } from "../../utils/styles";
const techniques = [{
  title: "3D printen",
  text: "Lampen, vazen en seizoensdecoratie — laag voor laag opgebouwd."
}, {
  title: "Laser snijden & graveren",
  text: "Naamborden, schaduwboxen en huisnummers in hout en acryl."
}, {
  title: "CNC frezen",
  text: "Wanddecoratie, logo's en panelen met strakke details."
}];
export function StudioStory() {
  return <section id="werkwijze" aria-labelledby="studio-heading" className="scroll-mt-24 bg-paper py-16 lg:py-24" data-id="element-214" data-mp="3i7k5we6wvi8k">
      <div className={`${container} grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-20`} data-id="element-215" data-mp="38fnu60bwjtlv">
        <div className="lg:order-2" data-id="element-216" data-mp="38dbddqhvrpae">
          <div className="overflow-hidden rounded-xl bg-sand" data-id="element-217" data-mp="2ufmsiintci5c">
            <img src={media.studio} alt="3D-printer die een witte geribbelde lampenkap print in de studio" loading="lazy" className="aspect-[4/5] w-full object-cover" data-id="element-218" data-mp="2ui93ks9wxfsb" />
          </div>
        </div>

        <div className="lg:order-1" data-id="element-219" data-mp="hpkzwea3h36v">
          <h2 id="studio-heading" className="text-3xl font-medium tracking-[-0.03em] text-ink lg:text-5xl lg:leading-[1.05]" data-id="element-220" data-mp="dmwnjwm69e55">
            Gemaakt in onze eigen studio
          </h2>
          <p className="mt-4 max-w-md text-[16px] leading-relaxed text-ink/70" data-id="element-221" data-mp="mn30nhdykc3s">
            Van idee tot eindproduct doen we alles zelf. Zo houden we grip op kwaliteit — en kunnen we bijna alles op maat maken.
          </p>
          <dl className="mt-10 space-y-6" data-id="element-222" data-mp="3q4l3faevisxc">
            {techniques.map(t => <div key={t.title} className="grid gap-1 sm:grid-cols-[200px_1fr] sm:gap-6" data-id="element-223" data-mp="8njzj8jke10z">
                <dt className="text-[15px] font-medium text-ink" data-id="element-224" data-mp="3vto0z8w577z">{t.title}</dt>
                <dd className="text-[15px] text-muted" data-id="element-225" data-mp="3cc59cz3ya58k">{t.text}</dd>
              </div>)}
          </dl>
          <Link to="/#maatwerk" className={`${btnPrimary} mt-10`} data-id="element-226" data-mp="37dbryvljlu34">
            Vraag maatwerk aan <ArrowRightIcon className="h-4 w-4" data-id="element-227" data-mp="1b9xbpvp4jcoz" />
          </Link>
        </div>
      </div>
    </section>;
}